import React, { useState } from 'react';
import { Row, Button, Select, Tag } from 'antd';
import { CloseOutlined } from '@ant-design/icons';

const { Option } = Select;

function getPriorityTagColor(priority) {
  switch (priority) {
    case 'Critical':
      return 'red';
    case 'Major':
      return 'orange';
    case 'Minor':
      return 'blue';
    default:
      return 'blue';
  }
}
function getPriorityTagDescription(priority) {
  return priority || 'Minor';
}

const IssuesSelector = ({ allIssues }) => {
  const [selectedIssues, setSelectedIssues] = useState([]);
  const [selectVisible, setSelectVisible] = useState(false);

  const handleRemoveIssue = (id) => {
    setSelectedIssues(selectedIssues.filter((issue) => issue.id !== id));
  };

  const handleChange = (selectedIds) => {
    const newSelected = allIssues.filter((issue) =>
      selectedIds.includes(issue.id)
    );
    setSelectedIssues(newSelected);
  };

  return (
    <div style={{ margin: '16px 0' }}>
      <Row>
        {selectedIssues.map((issue) => (
          <div
            key={issue.id}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              border: '1px solid #d9d9d9',
              borderRadius: 4,
              padding: '2px 8px',
              marginRight: 8,
              marginBottom: 8,
            }}
          >
            <Tag
              color={getPriorityTagColor(issue.priority)}
              style={{ marginRight: 4, marginBottom: 0 }}
            >
              {getPriorityTagDescription(issue.priority)}
            </Tag>
            <span>{issue.name}</span>
            <CloseOutlined
              style={{ marginLeft: 8, cursor: 'pointer' }}
              onClick={() => handleRemoveIssue(issue.id)}
            />
          </div>
        ))}

        {selectVisible ? (
          <Select
            mode="multiple"
            style={{ width: 300 }}
            placeholder="Select issues"
            value={selectedIssues.map((i) => i.id)} // array of selected IDs
            onChange={handleChange}
            onBlur={() => setSelectVisible(false)}
            autoFocus
          >
            {allIssues.map((issue) => (
              <Option key={issue.id} value={issue.id}>
                <Tag
                  color={getPriorityTagColor(issue.priority)}
                  style={{ marginRight: 4 }}
                >
                  {getPriorityTagDescription(issue.priority)}
                </Tag>
                {issue.name}
              </Option>
            ))}
          </Select>
        ) : (
          <Button icon="plus" onClick={() => setSelectVisible(true)}>
            Add Issue
          </Button>
        )}
      </Row>
    </div>
  );
};

export default IssuesSelector;
